import styled from 'styled-components';

import useDayNavigation from '../hooks/useDayNavigation';
import CalendarLegend from '../shared/CalendarLegend';

import DayDateNavigation from './DayDateNavigation';
import DayViewColumn from './DayViewColumn';

export default function DayView() {
  const { startDate } = useDayNavigation();

  return (
    <Container>
      <Header>
        <DayDateNavigation />
        <CalendarLegend />
      </Header>
      <CalendarContainer>
        <DayViewColumn date={startDate} />
      </CalendarContainer>
    </Container>
  );
}

const Container = styled.div`
  display: flex;
  flex-direction: column;
  height: 100%;
  gap: 24px;
`;

const Header = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex-wrap: wrap;
  gap: 16px;
`;

const CalendarContainer = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1;
  min-height: 0;
  background-color: ${({ theme }) => theme.colors.white};
  border-radius: 8px;
  overflow: hidden;
  box-shadow: 0 1px 3px ${({ theme }) => theme.colors.boxShadow};
`;
